import BaseModel from '../base/BaseModel.model';
export default class ContactUser extends BaseModel {
    public userId?: number;
    public hasPhone?: boolean;
    public phoneNumber?: string;
    public email?:  string;

    constructor(){
        super();

        this.init();
    }

    init(){ 
        this.userId = undefined;
        this.phoneNumber = "";
        this.email = "";
        this.hasPhone = false;

        
    }
}